jQuery(function () {
    var popup = $('#plan-tutorial-popup');
    if (popup.length < 1) {
        return;
    }
    var images = $('.plan-tutorial__image');
    var paragraphs = $('.plan-tutorial__paragraph');
    $('.js-plan-open-tutorial-btn').on('click', function () {
        popup.closest('.popup-overlay').addClass('visible');
    });
    $('.js-plan-tutorial-next-btn').on('click', function () {
        var activeImage = images.filter('.active');
        var activeParagraph = paragraphs.filter('.active');
        if (activeImage.next().length > 0 && activeParagraph.next().length > 0) {
            activeImage.next().addClass('active');
            activeParagraph.next().addClass('active');
        }
        else {
            activeImage.parent().children().first().addClass('active');
            activeParagraph.parent().children().first().addClass('active');
        }
        activeImage.removeClass('active');
        activeParagraph.removeClass('active');
    });
    $('.js-plan-tutorial-prev-btn').on('click', function () {
        var activeImage = images.filter('.active');
        var activeParagraph = paragraphs.filter('.active');
        if (activeImage.prev().length > 0 && activeParagraph.prev().length > 0) {
            activeImage.prev().addClass('active');
            activeParagraph.prev().addClass('active');
        }
        else {
            activeImage.parent().children().last().addClass('active');
            activeParagraph.parent().children().last().addClass('active');
        }
        activeImage.removeClass('active');
        activeParagraph.removeClass('active');
    });
});
